(function () {
  'use strict';

  /* ───── helpers ───── */
  function getRoot() {
    return document.getElementById('YouMayAlsoLike');
  }

  function moneyFormat(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, Shopify.money_format || '${{amount}}');
    }
    // Fallback: simple dollar format
    return '$' + (cents / 100).toFixed(2);
  }

  function routesRoot() {
    return (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) || '/';
  }

  /* ───── Swiper init / destroy ───── */
  function initSwiper() {
    var root = getRoot();
    if (!root || typeof Swiper === 'undefined') return;
    var swiperEl = root.querySelector('.you-may-also-like__swiper');
    if (!swiperEl) return;

    if (window.youMayAlsoLikeSwiper) {
      window.youMayAlsoLikeSwiper.destroy(true, true);
      window.youMayAlsoLikeSwiper = null;
    }
    swiperEl.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden');

    requestAnimationFrame(function () {
      window.youMayAlsoLikeSwiper = new Swiper(swiperEl, {
        slidesPerView: 1.15,
        freeMode: true,
        spaceBetween: 12,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        resizeObserver: true,
        watchSlidesProgress: true
      });
    });
  }

  /* ───── Fetch cart ───── */
  function fetchCart() {
    return fetch(routesRoot() + 'cart.js')
      .then(function (r) { return r.json(); })
      .catch(function (err) {
        console.error('[YouMayAlsoLike] cart fetch failed', err);
        return null;
      });
  }

  /* ───── Fetch product recommendations (JSON endpoint) ───── */
  function fetchRecommendations(productIds) {
    if (!productIds || productIds.length === 0) {
      return Promise.resolve([]);
    }
    console.log('[YouMayAlsoLike] fetching recommendations for', productIds);

    return Promise.all(
      productIds.map(function (id) {
        var url = routesRoot() + 'recommendations/products.json?product_id=' + id + '&limit=4&intent=related';
        return fetch(url)
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then(function (data) {
            return data.products || [];
          })
          .catch(function (err) {
            console.error('[YouMayAlsoLike] recommendations failed for product', id, err);
            return [];
          });
      })
    ).then(function (results) {
      // Flatten & deduplicate by product id
      var all = [].concat.apply([], results);
      var seen = {};
      return all.filter(function (p) {
        if (seen[p.id]) return false;
        seen[p.id] = true;
        return true;
      });
    });
  }

  /* ───── Build a single slide HTML ───── */
  function buildSlide(product) {
    // JSON API: variants is an array; pick first available or just first
    var variant = null;
    if (product.variants && product.variants.length) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) { variant = product.variants[i]; break; }
      }
      if (!variant) variant = product.variants[0];
    }
    if (!variant) return '';

    var imageUrl = '';
    var imageAlt = product.title || '';
    if (product.featured_image) {
      imageUrl = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src || '';
      if (product.featured_image.alt) imageAlt = product.featured_image.alt;
    } else if (product.images && product.images.length) {
      imageUrl = typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src || '';
    }

    var variantAvailable = variant.available !== false;
    var variantId = variant.id;
    var price = variant.price;
    var productUrl = product.url || ('/products/' + product.handle);

    // Variant label (skip "Default Title")
    var variantOption = '';
    if (variant.title && variant.title !== 'Default Title') {
      var optName = (product.options && product.options[0]) || 'Option';
      variantOption = '<p class="you-may-also-like__variant">' + optName + ' : ' + variant.title + '</p>';
    }

    return '' +
      '<div class="swiper-slide you-may-also-like__slide" data-product-id="' + product.id + '" data-variant-id="' + variantId + '">' +
      '<div class="you-may-also-like__card">' +
      '<div class="you-may-also-like__image">' +
      (imageUrl ? '<img src="' + imageUrl + '" alt="' + imageAlt + '" loading="lazy" width="90" height="90">' : '') +
      '</div>' +
      '<div class="you-may-also-like__info">' +
      '<a href="' + productUrl + '" class="you-may-also-like__title">' + product.title + '</a>' +
      variantOption +
      '<p class="you-may-also-like__price">' + moneyFormat(price) + '</p>' +
      '<button type="button" class="you-may-also-like__add-btn" data-variant-id="' + variantId + '"' + (variantAvailable ? '' : ' disabled') + '>' +
      (variantAvailable ? 'Add' : 'Sold out') +
      '</button>' +
      '</div>' +
      '</div>' +
      '</div>';
  }

  /* ───── Render slides ───── */
  function renderSlides(products) {
    var root = getRoot();
    if (!root) return;
    var wrapper = root.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    wrapper.innerHTML = products.map(buildSlide).join('');
  }

  /* ───── Toggle empty state ───── */
  function toggleEmpty(isEmpty) {
    var root = getRoot();
    if (!root) return;
    root.classList.toggle('is-empty', isEmpty);
  }

  /* ───── Main: load recommendations and render ───── */
  function loadAndRender() {
    var root = getRoot();
    if (!root) return;

    fetchCart().then(function (cart) {
      if (!cart || !cart.items || cart.items.length === 0) {
        toggleEmpty(true);
        return;
      }

      var productIds = [];
      var seen = {};
      cart.items.forEach(function (item) {
        if (!seen[item.product_id]) {
          seen[item.product_id] = true;
          productIds.push(item.product_id);
        }
      });

      fetchRecommendations(productIds).then(function (recs) {
        // Filter out products already in the cart
        var cartProductIds = {};
        cart.items.forEach(function (item) { cartProductIds[item.product_id] = true; });
        var filtered = recs.filter(function (p) { return !cartProductIds[p.id]; });

        console.log('[YouMayAlsoLike] showing', filtered.length, 'recommendations');

        if (filtered.length > 0) {
          toggleEmpty(false);
          renderSlides(filtered);
          initSwiper();
        } else {
          toggleEmpty(true);
        }
      });
    });
  }

  /* ───── Add-to-cart handler ───── */
  function addToCart(variantId, btn) {
    if (!variantId) return;
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = 'Adding...';

    fetch(routesRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function (data) {
        // Remove the slide that was just added
        var slide = btn.closest('.swiper-slide');
        if (slide) slide.remove();

        // Refresh the cart drawer markup
        updateCartDrawerMarkup(data.sections);

        setTimeout(function () { initSwiper(); }, 100);

        // Publish cart update event for Dawn
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'you-may-also-like', cartData: data });
        }
      })
      .catch(function (err) {
        console.error('[YouMayAlsoLike] add to cart failed', err);
        btn.disabled = false;
        btn.textContent = original;
      });
  }

  /* ───── Update cart-drawer markup after add-to-cart ───── */
  function updateCartDrawerMarkup(sections) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !sections || !sections['cart-drawer']) return;
    var parser = new DOMParser();
    var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
    var newDrawer = doc.querySelector('cart-drawer');
    if (!newDrawer) return;
    drawer.innerHTML = newDrawer.innerHTML;
    if (typeof drawer.open === 'function') drawer.open();
    requestAnimationFrame(function () {
      loadAndRender();
    });
  }

  /* ───── Event listeners ───── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.you-may-also-like__add-btn');
    if (!btn) return;
    addToCart(btn.dataset.variantId, btn);
  });

  // Subscribe to Dawn pub/sub cart updates
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (ev && ev.source === 'you-may-also-like') return;
      loadAndRender();
    });
  }

  // Initial load
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(loadAndRender, 200);
  } else {
    window.addEventListener('DOMContentLoaded', function () {
      setTimeout(loadAndRender, 200);
    });
  }

  // Dawn cart drawer re-render event
  document.addEventListener('cartDrawerContentRendered', function () {
    loadAndRender();
  });

})();
